import type { RequestForm } from "~/types/main";
import { FormApi } from "~/services/form.api";

export const FormService = new (class {
  async postRequestForm(body: RequestForm) {
    const response = await FormApi.postRequestForm(body);
    return response;
  }
})();
